<template>
  <!-- Table Container Card -->
  <b-card id="page-subcriptions" no-body class="mb-0 p-2">
    <b-card-header class="pl-0 pr-0">
      <b-card-title
        ><h2>{{ $t(label("title")) }}</h2></b-card-title
      >
      <b-button id="tooltip-create" variant="primary" @click="onCreate">
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span class="text-nowrap">{{ $t(label("register")) }}</span>
      </b-button>
      <b-tooltip
        placement="top"
        target="tooltip-create"
        triggers="hover"
        @click="onInfo"
      >
        <strong>
          <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
          Ver tutorial
        </strong>
        <span> </span>
      </b-tooltip>
    </b-card-header>
    <Filterss
      :fields="fieldsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />
    <!-- table -->
    <b-table
      id="subcriptions-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <!-- A custom formatted header cell for field 'name' -->
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>

      <template #cell(nameType)="data">
        <b-badge pill :variant="tagsColor(data.value)">
          {{ data.value }}
        </b-badge>
      </template>

      <template #cell(actions)="data">
        <feather-icon
          class="text-success mr-25"
          size="18"
          icon="FileTextIcon"
          @click="onShow(data.item.guid)"
        />

        <feather-icon
          class="text-primary mr-25"
          size="18"
          icon="EditIcon"
          @click="onEdit(data.item.guid)"
        />

        <feather-icon
          class="text-danger"
          size="18"
          icon="Trash2Icon"
          @click="onDelete(data.item.guid)"
        />
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>

    <!-- pagination -->
    <div class="mx-2">
      <b-row>
        <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{
              $t("perPage")
            }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
              @change="handlePerPageChange"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BFormGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { allSubcriptions, deleteSubcription } from "@core/api/request";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import Filterss from "../components/filters/Filterss.vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    Filterss,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    model: "subscriptions",
    loading: false,
    totalRows: null,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    headVariant: "light",
    items: [],
    fields: [
      { label: "name", key: "name", sortable: true },
      { label: "type", key: "nameType", sortable: true },
      { label: "price", key: "price", sortable: true },
      { label: "duration-days", key: "durationInDays", sortable: true },
      { label: "cant-message", key: "cantMessage", sortable: true },
      { label: "action", key: "actions", sortable: false },
    ],
    fieldsToFilters: [
      {
        name: "name",
        type: "text",
        placeholder: "name",
        type: "search",
        visible: true,
      },
    ],
    appliedFilters: {},
  }),

  mounted() {
    this.loadSubscriptions();
  },

  methods: {
    label(field) {
      return `pages.subscriptions.table.${field}`;
    },

    labelHeader(field) {
      return `pages.subscriptions.table.tableHeader.${field}`;
    },

    tagsColor(tag) {
      if (tag === "Anual") return "light-success";
      if (tag === "Mensual") return "light-primary";
      if (tag === "Prueba gratuita") return "light-danger";
      return "light-warning";
    },

    chargeParams() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      return getParams(arrParams);
    },

    chargeParamsWithFilters(name) {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      arrParams.push(`name,${name}`);
      return getParams(arrParams);
    },
    loadSubscriptions() {
      const param = this.chargeParams();
      this.loading = !this.loading;
      allSubcriptions(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    loadSubscriptionsWithFilters(name) {
      const param = this.chargeParamsWithFilters(name);
      this.loading = !this.loading;
      allSubcriptions(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          if (resp.data == null) {
            this.alertToast(
              "danger",
              `Error`,
              `No se encontraron coincidencias`,
            );
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    handlePageChange(value) {
      // this.currentPage = value
      this.loadSubscriptions();
    },

    handlePerPageChange() {
      // Reset currentPage to 1 when changing perPage
      this.currentPage = 1;
      this.loadSubscriptions();
    },

    onCreate() {
      this.$router.push({
        name: "subcriptionCreate",
        params: {
          option: 1, // option 1 to create
        },
      });
    },
    applyFilters(filters) {
      this.appliedFilters = filters;

      this.loadSubscriptionsWithFilters(filters.name);
    },
    resetFilters() {
      this.appliedFilters = {};

      this.loadSubscriptions();
    },

    onShow(guid) {
      this.$router.push({
        name: "subcriptionEdit",
        params: {
          option: 2, // option 2 to show
          guid: guid,
        },
      });
    },

    onEdit(guid) {
      this.$router.push({
        name: "subcriptionEdit",
        params: {
          option: 3, // option 3 to edit
          guid: guid,
        },
      });
    },

    onInfo() {},

    onDelete(guid) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteSubcription(guid)
            .then((resp) => {})
            .catch((error) => {
              this.alertToast("danger", this.$t("codeAlert"), error.message);
            })
            .finally(() => {
              stopLoading();
              this.loadSubscriptions();
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },

    message(title, text, icon) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
